export default {
  en: {
    menu: {
      orgDetails: 'Organisation details',
      products: 'Products and services',
      thirdParties: 'Critical suppliers',
      assets: 'Assets',
    },
    nextSection: 'Next section',
    skipSection: 'Skip section',
    productSettings: {
      description:
        'Which products & services do you offer your clients? Adding these will help you answer security questions related to these products.',
      add: 'Add product',
    },
    assetSettings: {
      subtitle:
        "Which domains and subdomains are associated with your organisation's services? Adding these will help you better understand your external security posture.",
    },
    unconfirmedCriticalSuppliers: {
      subtitle: 'We think these might be your suppliers',
      byline: 'Select which are correct and we will add them to your supplier list',
      confirmSupplierError: 'Failed to confirm supplier',
    },
    criticalSuppliers: {
      subtitle:
        'Which suppliers that you work with are critical to your company? Adding these will help your clients understand their supply chain',
      emptyTitle: 'No critical suppliers',
      emptySubtitle: `Leave this empty if you don't work with any suppliers that are critical to your business`,
      hideBanner:
        'Below are the suppliers your organisation has tagged as critical. To hide any from other organisations, click the icon next to the supplier. You can manage your hidden suppliers in Settings.',
      deleteBanner:
        'Below are the suppliers your organisation has tagged as critical. To remove any from your organisation, click the icon next to the supplier.',
      noActionBanner: 'Below are the suppliers your organisation has tagged as critical.',
      supplier: 'Supplier',
      connectedAt: 'Date added',
      removeSupplier: 'Remove supplier',
      hideSupplier: 'Hide supplier',
      toggleSupplierPrivacyError: 'Failed to hide supplier',
      removeSupplierError: 'Failed to remove supplier',
      addSupplier: 'Add supplier',
      addSupplierModal: {
        title: 'Add critical suppliers',
        done: 'Done',
        supplier: 'Supplier',
        add: 'Add',
        newCTA: 'Not seeing the right company?',
        added: 'Added',
        newSupplier: 'Add new supplier',
        name: 'Name',
        namePlaceholder: 'Enter supplier name...',
        location: 'Location',
        locationPlaceholder: 'Enter supplier location...',
        website: 'Website',
        websitePlaceholder: 'example.com',
        back: 'Back',
        noResults: 'No company found',
        success: 'New supplier added',
        error: 'Failed to create supplier',
      },
    },
  },
};
